import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, useNavigate } from 'react-router-dom'
import { ConvexReactClient } from 'convex/react'
import { ConvexProviderWithAuth0 } from 'convex/react-auth0'
import { Auth0Provider, type AppState } from '@auth0/auth0-react'
import '@fontsource-variable/roboto/wght.css'
import App from './App.tsx'
import './index.css'

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string)

const auth0Domain = import.meta.env.VITE_AUTH0_DOMAIN as string
const auth0ClientId = import.meta.env.VITE_AUTH0_CLIENT_ID as string

// Verifica che le variabili d'ambiente siano configurate
if (!auth0Domain || auth0Domain === 'undefined') {
  console.error('❌ VITE_AUTH0_DOMAIN non configurato correttamente:', auth0Domain)
  throw new Error('VITE_AUTH0_DOMAIN deve essere configurato nel file .env.local')
}

if (!auth0ClientId || auth0ClientId === 'undefined') {
  console.error('❌ VITE_AUTH0_CLIENT_ID non configurato correttamente:', auth0ClientId)
  throw new Error('VITE_AUTH0_CLIENT_ID deve essere configurato nel file .env.local')
}

function AppAuth0Provider({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate()

  const onRedirectCallback = React.useCallback(
    (appState?: AppState) => {
      const requestedPath = appState?.returnTo
      const safePath =
        typeof requestedPath === 'string' &&
        requestedPath.startsWith('/') &&
        !requestedPath.startsWith('//')
          ? requestedPath
          : '/'

      navigate(safePath, { replace: true })
    },
    [navigate]
  )

  return (
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      authorizationParams={{
        redirect_uri: window.location.origin,
        scope: "openid profile email"
      }}
      useRefreshTokens={true}
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  )
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AppAuth0Provider>
        <ConvexProviderWithAuth0 client={convex}>
          <App />
        </ConvexProviderWithAuth0>
      </AppAuth0Provider>
    </BrowserRouter>
  </React.StrictMode>,
)
